/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRIRecommendationsRequest {
    getFixupPrototypeFunction() { return ListRIRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ListRIRecommendationsRequest>): ListRIRecommendationsRequest {
        let obj = Object.assign(new ListRIRecommendationsRequest(), model);
        ListRIRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRIRecommendationsRequest>): ListRIRecommendationsRequest {
        if (!model) return null;
        return ListRIRecommendationsRequest.newInstance(<ListRIRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRIRecommendationsRequest) {
        if (!obj) return;

        models.ListRIRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRIRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ListRIRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    services: Array<models.CloudServiceName>;

    /**
     * Year, it can be 1 or 3
     */
    term: string;

    /**
     * flag to indicate whether to include compute forecast in the response
     */
    compute_forecast: boolean;

    /**
     * Select a payment option, it can be No_Upfront, Partial_Upfront or All_Upfront. payment_option: No_Upfront
     */
    payment_option: string;

}
